export const iconFontAwesomeMedicalHealthVial = (
	<i className="fa-solid fa-vial"></i>
);
